<template>
  <div>
    <sales-agents-invoice-commission-fee-modal></sales-agents-invoice-commission-fee-modal>
    <history-modal-content></history-modal-content>
    <div class="d-flex justify-content-end">
      <div class="d-flex justify-content-between button-group">
        <b-button v-if="currentRoutePermissions.delete_saleagentcommissionfee" variant="danger"
                  @click="deleteCommissionFee">{{$t('buttons.agents.delete_commission_fee')}}
        </b-button>
        <b-button v-if="currentRoutePermissions.change_saleagentcommissionfee" variant="success" @click="createInvoice">
          {{$t('buttons.agents.create_invoice')}}
        </b-button>
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.common.buyer')}}</label>
            <multiselect v-model="searchData.buyers" :max-height="200"
                         placeholder="Choose buyer" label="name" track-by="id"
                         :options="customers" :multiple="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.agents.commission_type')}}</label>
            <multiselect v-model="searchData.commission_type" :max-height="200"
                         placeholder="Choose commission type" label="name" track-by="key"
                         :options="commissionTypes" :multiple="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.agents.agent_invoice_number')}}</label>
            <input class="form-control" v-model="searchData.agent_invoice_number" @keyup.enter="search"
                   placeholder="Enter agents invoice No">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.agent')}}</label>
            <multiselect v-model="searchData.agents" :max-height="200"
                         placeholder="Choose agent" label="name" track-by="id"
                         :options="agents" :multiple="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.agents.commission_currency')}}</label>
            <multiselect v-model="searchData.currencies" :max-height="200"
                         placeholder="Choose currency" label="code" track-by="code"
                         :options="currencies" :multiple="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.agents.sales_invoice_number')}}</label>
            <input class="form-control" v-model="searchData.sales_invoice_number" @keyup.enter="search"
                   placeholder="Enter sales invoice No">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.seller')}}</label>
            <multiselect v-model="searchData.sellers" :max-height="200"
                         placeholder="Choose seller" label="name" track-by="id"
                         :options="sellers" :multiple="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.agents.invoices')}}</label>
            <multiselect v-model="searchData.invoiced" :max-height="200"
                         placeholder="Choose invoiced status" label="name" track-by="name"
                         :options="invoiced"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.agents.sales_invoice_date')}}</label>
            <range-date-picker v-model="searchData.range_date" range lang="en"
                               range-separator="/" :first-day-of-week="1"></range-date-picker>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col cols="4">
            <input class="form-control"
                   placeholder="Filter..."
                   @input="setQuickFilter">
          </b-col>
          <b-col cols="4" offset="4" class="vertical-center-container d-flex justify-content-end">
            <label for="pagination-toggle" class="margin-right-5">Pagination</label>
            <input id="pagination-toggle" type="checkbox"
                   title="this checkbox needed for toggle pagination bar" v-model="paginationState"
                   @change="togglePagination">
            <save-columns-btn :grid="commissionFeesGridOptions" :grid-name="gridName"
                              class="margin-left-5"></save-columns-btn>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col>
            <ag-grid-vue class="ag-theme-balham grid" :gridOptions="commissionFeesGridOptions"
                         @filterChanged="filterChangeHandler"
                         :pinnedBottomRowData="salesCommissionFeesPinnedRowData" :postProcessPopup="postProcessPopup"
                         :columnDefs="salesCommissionFeesColumns" :rowData="commissionFees">
            </ag-grid-vue>
          </b-col>
        </b-row>
        <b-row class="pagination__wrapper" v-if="paginationState">
          <b-col cols="5">
            <div class="pagination-info">{{countOfViewCommissionFees}} {{$t('common_content.of')}}
              {{salesAgentCommissionFeesCount}}
            </div>
          </b-col>
          <b-col cols="7">
            <b-pagination size="md" :total-rows="salesAgentCommissionFeesCount" :per-page="searchObject.limit"
                          v-model="currentPaginateIndex"
                          @input="changePaginateState"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import {
    mapGetters,
    mapState
  } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import RangeDatePicker from 'vue2-datepicker';
  import moment from 'moment';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import HistoryModalContent from '@/components/modals/HistoryModal';
  import SalesAgentsInvoiceCommissionFeeModal from '@/components/modals/SalesAgentsInvoiceCommissionFeeModal';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import {
    cleanFilters,
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      RangeDatePicker,
      SaveColumnsBtn,
      SalesAgentsInvoiceCommissionFeeModal,
      HistoryModalContent,
      'ag-grid-vue': AgGridVue
    },
    data() {
      return {
        searchData: {
          buyers: [],
          commission_type: [],
          agents_invoice_number: '',
          sales_invoice_number: '',
          agents: [],
          currencies: [],
          sellers: [],
          invoiced: '',
          range_date: ''
        },
        searchObject: {
          limit: 100,
          offset: 0
        },
        paginationState: true,
        currentPaginateIndex: 1,
        invoiced: [{boolean: true, name: 'Yes'}, {boolean: false, name: 'No'}],
      }
    },
    methods: {
      async filterChangeHandler(event) {
        const items = [];
        event.api.forEachNodeAfterFilterAndSort(({ data: { id } }) => {
          items.push(id);
        });
        await this.$store.dispatch('accounting/updateTotalDataForIds', { ...this.searchObject, id: items.toString() });
        event.api.hideOverlay();
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      search() {
        this.currentPaginateIndex = 1;
        this.searchObject = {
          ...this.searchObject,
          agents: getArrayByProperty(this.searchData.agents, 'id').toString(),
          buyers: getArrayByProperty(this.searchData.buyers, 'id').toString(),
          sellers: getArrayByProperty(this.searchData.sellers, 'id').toString(),
          currencies: getArrayByProperty(this.searchData.currencies, 'id').toString(),
          invoiced: this.searchData.invoiced ? this.searchData.invoiced.boolean : '',
          commission_types: getArrayByProperty(this.searchData.commission_type, 'key').toString(),
          sales_invoice_nr: this.searchData.sales_invoice_number,
          sales_agent_invoice_nr: this.searchData.agent_invoice_number,
          sales_invoice_date_between_after: this.searchData.range_date && this.searchData.range_date[0] ? moment(this.searchData.range_date[0]).format(DATE_FORMAT) : '',
          sales_invoice_date_between_before: this.searchData.range_date && this.searchData.range_date[1] ? moment(this.searchData.range_date[1]).format(DATE_FORMAT) : ''
        };
        this.$store.dispatch('accounting/loadSaleAgentCommissionsFeesList', this.searchObject);
      },
      deleteCommissionFee() {
        const selectedCommissionFees = {ids: getArrayByProperty(this.commissionFeesGridOptions.api.getSelectedRows(), 'id')};
        if (selectedCommissionFees.ids && selectedCommissionFees.ids.length) {
          this.$http.delete(`accounting/sale_agent_commissions/`, {body: selectedCommissionFees}).then((response) => {
            this.$notify(setNotifyData('Success', response.body, 'success'));
            this.search();
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        } else {
          this.$notify(setNotifyData('Error', 'Select at least one commission fee', 'error'));
        }
      },
      createInvoice() {
        const savedData = {fees: getArrayByProperty(this.commissionFeesGridOptions.api.getSelectedRows(), 'id')}
        if (savedData.fees.length) {
          this.$http.post(`accounting/create_sai_from_fees/`, savedData).then(handlerResponse)
            .then((response) => {
              this.$router.push({path: `/sales-agent-invoices/${response.id}`});
            }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$router.push({path: `/sales-agent-invoices/new`});
        }
      },
      clearData() {
        this.$store.commit('accounting/setSaleAgentCommissionFeesList', []);
      },
      setQuickFilter(e) {
        this.commissionFeesGridOptions.api.setQuickFilter(e.target.value);
      },
      togglePagination() {
        if (!this.paginationState) {
          delete this.searchObject.limit;
          delete this.searchObject.offset;
        } else {
          this.searchObject.limit = 100;
          this.searchObject.offset = 0;
        }
        this.search();
      },
      changePaginateState() {
        const searchObject = {...this.searchObject, offset: (this.currentPaginateIndex - 1) * this.searchObject.limit};
        this.$store.dispatch('accounting/loadSaleAgentCommissionsFeesList', searchObject);
      }
    },
    beforeMount() {
      this.$store.cache.dispatch('generic/loadCommissionTypes');
      this.$store.dispatch('accounting/loadSaleAgentCommissionsFeesList', this.searchObject);
      this.$store.dispatch('generic/getCurrencies');
      this.$store.dispatch('partners/getSaleAgents');
      this.$store.dispatch('partners/getSellers');
      this.$store.dispatch('partners/getCustomers');
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    },
    computed: {
      ...mapState('generic', ['currencies', 'commissionTypes', 'currentRoutePermissions']),
      ...mapState('partners', ['agents', 'sellers', 'customers']),
      ...mapState('accounting', ['gridName', 'salesCommissionFeesPinnedRowData', 'salesCommissionFeesColumns',
        'salesAgentCommissionFeesCount']),
      ...mapGetters('accounting', {
        commissionFees: 'salesAgentCommissionFeesList',
        commissionFeesGridOptions: 'commissionFeesGridOptions'
      }),
      countOfViewCommissionFees() {
        return this.commissionFees.length;
      }
    }
  }
</script>

<style scoped>

  .grid {
    height: calc(100vh - 400px);
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/agents/sales-commission-fees/SalesCommissionFeesList.vue